import { useEffect, useState, useRef } from 'react';
import { throttle } from '@/utils/index'
import { useGenerateRefByState } from "@/utils/useHooks";

export const useScroll = (ref, noScroll = false) => {
  const lastRecordTime = useRef(0)
  const lastRecordScrollTop = useRef(0)

  const lastScrollTop = useRef(0)

  const noScrollRef = useGenerateRefByState(noScroll)

  const scrollEvent = throttle(() => {
    const target = ref.current
    if (!target) {
      return
    }
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop

    if (noScrollRef.current) {
      target.classList[scrollTop > 30 ? 'add' : 'remove']('hideTop')
      return
    }

    const time = (new Date()).getTime()
    if (!lastRecordTime.current) {
      lastRecordTime.current = time
    }
    if (!lastRecordScrollTop.current) {
      lastRecordScrollTop.current = scrollTop
    }
    if (time - lastRecordTime.current > 1000) {
      lastRecordTime.current = time
      lastRecordScrollTop.current = scrollTop
    }
    // console.log('scrollTop', lastRecordScrollTop.current - scrollTop)
    if (scrollTop > 60) {
      // target.classList.contains('top10') && target.classList.remove('top10')
      // scroll up
      if (lastRecordScrollTop.current - scrollTop > 120) {
        target.classList.contains('hideTop') && target.classList.remove('hideTop')
        target.classList.add('top10')
      } else if (scrollTop > lastScrollTop.current) {
        target.classList.remove('top10')
        target.classList.add('hideTop')
      }
    } else if (scrollTop > 30) {
      target.classList.add('top10')
      target.classList.remove('hideTop')
    } else {
      target.classList.remove('hideTop')
      target.classList.remove('top10')
    }
    lastScrollTop.current = scrollTop
    // console.log('scrollTop', scrollTop)
  }, 50)

  useEffect(() => {
    window.addEventListener('scroll', scrollEvent)

    return () => {
      window.removeEventListener('scroll', scrollEvent)
    }
  }, [])

  return null
}
